// as this module contains the Core, we ensure that the Core has been booted
sap.ui.getCore?.().boot?.();